import cls from "classnames";
import { roundMemberCountForCreator } from "@qoohoo/common/utils/number";

export default function CreatorInfo({ userData }) {
  const memberCount =
    userData?.user_insights?.total_numbers_of_members_and_subscribers;
  const roundedMemberCount = roundMemberCountForCreator(memberCount);
  const memberCountMessage = (memberCount) => {
    if (memberCount > 100) {
      return `Join ${roundMemberCountForCreator(memberCount)}+ members`;
    } else {
      return `Join me today!`;
    }
  };

  return (
    <section className="relative mt-14 lg:mt-[120px] w-[305px] lg:w-auto max-w-sm mx-auto">
      <img
        src="/assets/icons/profile-star-1.svg"
        alt="star"
        className="absolute top-7 left-0 w-6 h-6"
      />
      <img
        src="/assets/icons/profile-star-2.svg"
        alt="star"
        className="absolute bottom-7 right-0 w-5 h-5"
      />
      <div className="flex flex-col justify-center items-center">
        <div className="mt-4 mb-6 text-center">
          <h1 className="text-2xl lg:text-[28px] lg:leading-[38px] font-semibold">
            {memberCountMessage(memberCount)}
          </h1>
        </div>

        {/* Members Image Group - Add logic based on number of subscriber */}
        {userData.user_insights?.total_number_of_subscribers ? (
          <div
            className={cls(
              "flex children:bg-[#1C2226] text-xs sm:text-base font-semibold sm:font-bold",
              memberCount > 5 && "mr-2"
            )}
          >
            {userData?.latest_subscribers.map((sub, id) => {
              return (
                <div
                  key={id}
                  className={cls(
                    "h-9 w-9 sm:w-10 sm:h-10 border-2 border-[#161A1D] rounded-full overflow-hidden",
                    {
                      "-ml-3 sm:-ml-4":
                        id !== 0 && userData?.latest_subscribers.length > 1,
                    }
                  )}
                >
                  <img
                    src={sub.avatar.url}
                    alt=""
                    className="w-full h-full object-cover object-center"
                  />
                </div>
              );
            })}
            {memberCount > 5 && (
              <div className="h-9 w-9 sm:w-10 sm:h-10 text-xs font-semibold border-2 border-[#161A1D] rounded-full -ml-3 sm:-ml-4 flex items-center justify-center">
                {roundedMemberCount}+
              </div>
            )}
          </div>
        ) : null}
      </div>
    </section>
  );
}
